import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const ProcedureScoresIndex = () => import('./Index.vue');
const ProcedureScoresEdit = () => import('./Edit.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/procedure-scores'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return {
              name: 'settings_procedure_scores_list',
              params: to.params,
            };
          },
        },
        {
          path: 'list',
          name: 'settings_procedure_scores_list',
          component: ProcedureScoresIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':procedureId/edit',
          name: 'settings_procedure_scores_edit',
          component: ProcedureScoresEdit,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
